import { VaultConnectionCard } from './VaultConnectionCard';
import useVaultConnections from './useVaultConnections';
import { LoadingIndicator, useNotify } from 'react-admin';
import { useEffect } from 'react';

export const VaultConnections = (props: any) => {
    const {data, isLoading, isError, error, refetch} = useVaultConnections();
    const notify = useNotify()
    useEffect(()=>{
        if(isError){
            console.log("Error in getting connections",error)
          //  notify("Failed to get connectors");
        }
    },[notify, isError, error])
    return (
        <>
            {
            !isLoading && !isError &&
                <>
                {
                    data?.map(connection=> <VaultConnectionCard key={connection.service} connection={connection} refetch={refetch}/>)
                }
                </>
            }
            {isLoading && <LoadingIndicator />}
        </>

    );
};
